<template>
  <b-row>

    <label class="file-select">
        <!-- <div class="select-button">
          <span v-if="value">Selected File: {{value.name}}</span>
          <span v-else>Select File</span>
        </div>  -->
        <button @click="onChoose"><icon name="edit"></icon></button>
        <input type="file" id="fileUpload" @change="handleFileChange" accept="image/*"/>
        <p v-if="error" class="error"><icon name="exclamation-circle"></icon> {{error}}</p>
      </label> 
      <button v-if="value" @click="onDelete"><icon name="trash"></icon></button>
  </b-row>
 </template>

<script>
export default {
  props: {
    value: File
  },
  data() {
    return {
        error:null
    }
  },
  methods: {
    onChoose() {
        document.getElementById("fileUpload").click()
    },
    onDelete() {
      this.$emit("input");
      this.$emit("cancelFile");
    },
    handleFileChange(e) {
      if(e.target.files[0]){
        let size = e.target.files[0].size;
        if(size > 1000000) {
          // the file exceeds the limit allowed
          this.error = '{{ $t("messages.exceededLimit") }}'
          return;
        }
        this.error = null;
        let selectedFile = URL.createObjectURL(e.target.files[0]);
        this.$emit("selectedFile", selectedFile);
        this.$emit("input", e.target.files[0]);
      }
    }
  }
};
</script>

<style scoped>
.file-select > .select-button {
  padding: 1rem;
  color: white;
  background-color: #2ea169;
  border-radius: 0.3rem;
  text-align: center;
  font-weight: bold;
}

.file-select > input[type="file"] {
  display: none;
}
.error {
  color:saddlebrown;
}
</style>


// WEBPACK FOOTER //
// src/components/utils/FileSelect.vue